import axios from "axios";
import React from "react";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import UserPool from "../../pages/login/UserPool";
export const AccessToken = (username, password) => {
  var bodyFormData = new FormData();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  bodyFormData.append("username", username);
  bodyFormData.append("password", password);
  axios
    .post(`${REACT_APP_BACKEND_ROUTE_URL}login/`, bodyFormData)
    .then((res) => {
      sessionStorage.setItem("accessToken", res.data.access);
      sessionStorage.setItem("refreshToken", res.data.refresh);
      sessionStorage.setItem("accessTokenTime", new Date().getTime());
      sessionStorage.setItem("subscriptionType", res.data.subscription_type);
      // sessionStorage.setItem('roleType', res.data.role)
      // sessionStorage.setItem('name', res.data.name)
      // sessionStorage.setItem('email', res.data.email)

      if (res.data.role === "partner admin") {
        sessionStorage.setItem("partner_id", res.data.partner_id);
      } else if (res.data.role === "partner user") {
        sessionStorage.setItem("partner_id", res.data.partner_id);
      } else if (res.data.role === "customer user") {
        sessionStorage.setItem("customer_name", res.data.customer_name);
        sessionStorage.setItem("partner_id", res.data.partner_id);
      } else if (res.data.role === "customer admin") {
        sessionStorage.setItem("customer_name", res.data.customer_name);
        sessionStorage.setItem("partner_id", res.data.partner_id);
      } else if (res.data.role === "facility admin") {
        sessionStorage.setItem("facility_name", res.data.facility_name);
      } else if (res.data.role === "facility user") {
        sessionStorage.setItem("facility_name", res.data.facility_name);
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err);
    });
};

// export const AccessToken = (username, password) => {
//   console.log("test", username, password);
//   return new Promise((resolve, reject) => {
//     var bodyFormData = new FormData();
//     const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
//     bodyFormData.append("username", username);
//     bodyFormData.append("password", password);

//     axios
//       .post(`${REACT_APP_BACKEND_ROUTE_URL}login/`, bodyFormData)
//       .then((res) => {
//         sessionStorage.setItem("accessToken", res.data.access);
//         sessionStorage.setItem("refreshToken", res.data.refresh);
//         sessionStorage.setItem("accessTokenTime", new Date().getTime());
//         sessionStorage.setItem("subscriptionType", res.data.subscription_type);

//         // sessionStorage.setItem("userName", res.data.userName);
//         // sessionStorage.setItem("roleType", res.data.role);
//         // sessionStorage.setItem("email", res.data.email);
//         // sessionStorage.setItem("name", res.data.name);
//         // sessionStorage.setItem("facility_name", res.data.facility_name);

//         if (res.data.role === "partner admin") {
//           sessionStorage.setItem("partner_id", res.data.partner_id);
//         } else if (res.data.role === "partner user") {
//           sessionStorage.setItem("partner_id", res.data.partner_id);
//         } else if (res.data.role === "customer user") {
//           sessionStorage.setItem("customer_name", res.data.customer_name);
//           sessionStorage.setItem("partner_id", res.data.partner_id);
//         } else if (res.data.role === "customer admin") {
//           sessionStorage.setItem("customer_name", res.data.customer_name);
//           sessionStorage.setItem("partner_id", res.data.partner_id);
//         } else if (res.data.role === "facility admin") {
//           sessionStorage.setItem("facility_name", res.data.facility_name);
//         } else if (res.data.role === "facility user") {
//           sessionStorage.setItem("facility_name", res.data.facility_name);
//         }
//         const user = UserPool.getCurrentUser(); // Get the current Cognito user
//         if (user) {
//             user.signOut(() => {
//               // Collect all keys that match the criteria
//               const keysToRemove = [];

//               for (let i = 0; i < localStorage.length; i++) {
//                 const key = localStorage.key(i);
//                 if (key && key.startsWith("CognitoIdentityServiceProvider")) {
//                   keysToRemove.push(key); // Add key to the list of keys to remove
//                 }
//               }

//               // Remove all matching keys
//               keysToRemove.forEach((key) => localStorage.removeItem(key));

//               console.log("All Cognito-related items removed from local storage");
//             });

//             console.log("User signed out from Cognito");
//           }

//         resolve(res.data); // Resolve the promise with the response data
//       })
//       .catch((err) => {
//         console.log(err);
//         toast.error(err.message || "Error occurred");
//         reject(err); // Reject the promise with the error
//       });
//   });
// };

export const RefreshToken = async (refreshToken) => {
  var bodyFormData = new FormData();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  bodyFormData.append("refresh", refreshToken);
  var refresh = false;
  await axios
    .post(`${REACT_APP_BACKEND_ROUTE_URL}login/refresh/`, bodyFormData)
    .then((res) => {
      if (res.data.access !== null && res.data.access !== undefined) {
        sessionStorage.setItem("accessToken", res.data.access);
        sessionStorage.setItem("accessTokenTime", new Date().getTime());
        refresh = true;
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err);
    });
  return refresh;
};

export const CheckToken = () => {
  var refresh = false;
  if (
    sessionStorage.getItem("accessToken") !== undefined &&
    sessionStorage.getItem("accessToken") !== null
  ) {
    var jwtExpTime = jwtDecode(sessionStorage.getItem("accessToken")).exp;
    var currentTime = new Date().getTime() / 1000;
    if (currentTime > jwtExpTime) {
      if (RefreshToken(sessionStorage.getItem("refreshToken"))) {
        refresh = true;
      }
    } else {
      refresh = true;
    }
    return refresh;
  }
  return refresh;
};

export const autoLoginWithExpiredRefreshToken = async (refreshToken) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_ROUTE_URL}auto_login_from_expired_refreshtoken/`,
      { refresh: refreshToken }
    );

    // const { access, refresh } = response?.data?.data;

    // if (access && refresh) {
    //   sessionStorage.setItem("accessToken", access);
    //   sessionStorage.setItem("refreshToken", refresh);
    //   return true;
    // }
    return response.data;
  } catch (error) {
    console.error("Auto login from expired refresh token failed", error);
  }
  return false;
};
